import { matchPath, useLocation, useParams } from "react-router-dom";
import ROUTES from "shared/routes";

export const useRouteQueryKeys = (): readonly unknown[][] => {
  const { pathname } = useLocation();
  const { actId, taskId, contractId, requestNumber, transactionsId } =
    useParams();

  if (matchPath(ROUTES.MAIN, pathname)) {
    return [
      ["acts"],
      ["requests"],
      ["cards"],
      ["profile"],
      ["return-transactions"],
      ["contracts"],
      ["batch-sign"],
    ];
  }

  if (matchPath(ROUTES.SING_ACT_ID, pathname)) {
    return [
      ["act", actId],
      ["file", actId],
    ];
  }

  if (matchPath(ROUTES.TASKS, pathname)) {
    return [["tasks"]];
  }

  if (matchPath(ROUTES.TASKS_ID, pathname)) {
    return [["task", taskId], ["act"]];
  }

  if (matchPath(ROUTES.PROFILE, pathname)) {
    return [["profile"]];
  }

  if (matchPath(ROUTES.CONTRACTS, pathname)) {
    return [["contracts"]];
  }

  if (matchPath(ROUTES.SING_CONTRACTS_ID, pathname)) {
    return [
      ["contract", contractId],
      ["file", contractId],
    ];
  }

  if (matchPath(ROUTES.REQUEST_ID, pathname)) {
    return [["request"]];
  }

  if (matchPath(ROUTES.REQUESTS, pathname)) {
    return [["request", requestNumber]];
  }

  if (matchPath(ROUTES.TRANSACTIONS_ID, pathname)) {
    return [["transactions", transactionsId]];
  }

  if (matchPath(ROUTES.IDENTITY_VERIFICATION_MAIN, pathname)) {
    return [["profile"], ["verification-data"]];
  }

  return [];
};
